import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { CreateChatHistoryInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const CreateChatHistoryMutation = graphql(`
  mutation CreateChatHistory($input: CreateChatHistoryInput!) {
    createChatHistory(input: $input) {
      id
      __typename
      client {
        id
        __typename
        name
        externalReference
      }
      sessionId
      messages
      createdAt
      updatedAt
    }
  }
`);

export function useCreateChatHistory() {
  const [result, createChatHistoryMutation] = useMutation(CreateChatHistoryMutation);
  const [error, setError] = useState<Error | null>(null);

  const createChatHistory = useCallback(
    async (input: CreateChatHistoryInput) => {
      try {
        const response = await createChatHistoryMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.createChatHistory;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [createChatHistoryMutation],
  );

  return { createChatHistory, result, error };
}
